.ugc-reviews-wrap {
  mark {
    background-color: transparent;
  }
}

.ugc-pdp-review-desktop-box {
  max-width: 1440px;
  min-width: 768px;
  padding: 32px;
  margin: 0 auto;
  position: relative;
}

@media screen and (max-width: 1024px) {
  .ugc-review-content {
    display: flex;
    flex-direction: column;
    .ugc-review-summary {
      display: flex;
      gap: 24px;
      .ugc-review-rating,
      .ugc-review-banner {
        flex: 1;
      }
    }
    .ugc-review-main {
      flex: 1;
    }
  }
  .ugc-review-sponsored-product {
    .sponsored-product-card {
      &__info {
        .percent-off {
          text-align: end;
        }
      }
    }
  }
}
@media screen and (min-width: 1025px) {
  .ugc-review-content {
    display: flex;
    flex-direction: row;
    gap: 24px;
    .ugc-review-summary {
      display: flex;
      flex: 0 0 320px;
      flex-direction: column;
    }
    .ugc-review-main {
      flex: 1;
      overflow: hidden;
    }
    .ugc-review-banner {
      padding-top: 16px;
      border-top: 1px solid var(--gray-300);
    }
  }
  .ugc-review-sponsored-product {
    .sponsored-product-card {
      &__info {
        .percent-off {
          text-align: start;
        }
      }
    }
  }
}

.ugc-review-sponsored-product {
  margin-top: 24px;
  .sponsored-product-card {
    width: 100%;
    max-width: 100%;
    margin: 0;
    &__info {
      .percent-off {
        flex-grow: 1;
      }
    }
    &__image {
      width: 128px;
      height: 128px;
      cms-lazy-load-image {
        width: 120px;
        height: 120px;
      }
      img {
        width: 120px;
        height: 120px;
      }
    }
  }
}
